@if (!widgetsLoaded) {
  <div fxLayout="row" fxLayoutAlign="space-between center" class="widget-bar">
    <div fxFill fxLayout="row" fxLayoutAlign="space-around center">
      <forge-skeleton class="widget placeholder"></forge-skeleton>
      <forge-skeleton class="widget placeholder"></forge-skeleton>
      <forge-skeleton class="widget placeholder"></forge-skeleton>
      <forge-skeleton class="widget placeholder"></forge-skeleton>
    </div>
  </div>
}

@if (widgetsLoaded) {
  <div fxFill fxLayout="row" fxLayoutAlign="space-between center" class="widget-bar">
    @if (hasPreviousPage) {
      <forge-icon-button (click)="goToPreviousPage()" aria-label="Go to previous widget page">
        <forge-tooltip>Previous</forge-tooltip>
        <forge-icon name="arrow_back"></forge-icon>
      </forge-icon-button>
    }
    <forge-view-switcher #viewSwitcher animation-type="slide" [index]="page" style="width: 100%;">
      @for (page of pages; track page) {
        <forge-view>
          <div fxFill fxLayout="row" fxLayoutAlign="space-around center">
            @for (widget of page; track widget) {
              <div>
                <widget fxFill [widget]="widget"></widget>
              </div>
            }
          </div>
        </forge-view>
      }
    </forge-view-switcher>
    @if (hasNextPage) {
      <forge-icon-button (click)="goToNextPage()" aria-label="Go to next widget page">
        <forge-tooltip>Next</forge-tooltip>
        <forge-icon name="arrow_forward"></forge-icon>
      </forge-icon-button>
    }
  </div>
}